export default __webpack_public_path__ + "static/media/CartBottom.35865825.svg";